import clsx from "clsx";
import { useContext } from "react";
import { LanguageContext } from "~/providers/LanguageProvider";
import { NormalizedDisclosure } from "~/types/search.types";

interface IDisclosureItem {
    disclosure: NormalizedDisclosure;
    isActive: boolean;
    isFetching: boolean;
    hasSelectedItems: boolean;
    btnClickCallback: (item: NormalizedDisclosure) => void;
}

const DisclosureItem = (props: IDisclosureItem) => {
    const { disclosure, isActive, isFetching, hasSelectedItems, btnClickCallback } = props;
    const { language } = useContext(LanguageContext);
    const disclosureName = disclosure?.label[language];

    const btnClass = clsx(
        "flex justify-between items-center h-9 p-2 rounded-1 text-sm text-stone-darkest font-medium-light tracking-[-0.28px] rounded hover:bg-stone-lighter",
        isActive && "bg-stone-lighter !font-bold"
    );
    const dot = <div className="w-1.5 h-1.5 bg-caramel-vibrant rounded"></div>;

    return (
        <button
            className={btnClass}
            onClick={() => btnClickCallback(disclosure)}
            disabled={isFetching}
        >
            <div>{disclosureName}</div>
            {hasSelectedItems && dot}
        </button>
    );
};

export default DisclosureItem;
